import { ReactElement } from "react";
import { Grid, Typography } from "@mui/material";
import { CardContainer } from "./CardContainer";
import "./StatusWidget.css";
import { LoadingIndicator } from "./Loading";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import PublicIcon from "@mui/icons-material/Public";
import { Box } from "@mui/system";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTheme } from "@mui/material/styles";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { AutomatedTestResult } from "../../../Home/UI/Interfaces";

export const StatusWidget = function ({
  data,
  text,
  icon,
  className,
  isLoading,
  lastUpdatedDate,
}: {
  text?: string;
  data: AutomatedTestResult[];
  className?: string;
  icon?: ReactElement;
  isLoading: boolean;
  lastUpdatedDate: string[];
}): ReactElement {
  dayjs.extend(utc);
  const theme = useTheme();
  return (
    <CardContainer className={className}>
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pl: 1 }}>
            <PublicIcon />
            <Typography variant="h6" component="h2">
              {text}
            </Typography>
          </Box>
        </Grid>
        <Grid item className="status-widget-body">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, pl: 5 }}>
                <Typography>Static Website</Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <LoadingIndicator show={isLoading}>
                    {data.filter(x=>x.testName == 'Website').pop()?.passed ? (
                      <CheckCircleIcon
                        sx={{
                          color: theme.palette.success.main,
                          fontSize: "2.5rem",
                          marginRight: 1,
                        }}
                      />
                    ) : (
                      <CancelOutlinedIcon
                        sx={{
                          color: theme.palette.error.main,
                          fontSize: "2.5rem",
                          marginRight: 1,
                        }}
                      />
                    )}
                  </LoadingIndicator>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, pl: 5 }}>
                <Typography>Ordering Site</Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <LoadingIndicator show={isLoading}>
                    {data.filter(x=>x.testName == 'OnlineOrdering').pop()?.passed ? (
                      <CheckCircleIcon
                      sx={{
                        color: theme.palette.success.main,
                        fontSize: "2.5rem",
                        marginRight: 1,
                      }}
                      />
                    ) : (
                      <CancelOutlinedIcon
                      sx={{
                        color: theme.palette.error.main,
                        fontSize: "2.5rem",
                        marginRight: 1,
                      }}
                      />
                    )}
                  </LoadingIndicator>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Typography variant="caption" color="textSecondary" sx={{ pl: 1 }}>
            {`Last updated: ${dayjs.utc(lastUpdatedDate[0]).local().format("MM/DD/YYYY hh:mm A")}`}
          </Typography>
        </Grid>
      </Grid>
    </CardContainer>
  );
};
